module.exports = __webpack_public_path__ + "img/group-icon.46bd38e9.png";